import { useRouter } from 'expo-router'
import { Modal } from 'react-native'
import { DS } from '@/design-system'
import { View } from 'react-native'
import { StyleSheet } from 'react-native'
import { useThrottledCallback } from 'use-debounce'
import { translate } from '../../i18n'
import { palette } from '../../theme/palette'

export const CantJoinModal = () => {
  const router = useRouter()
  const goBack = () => {
    if (router.canDismiss()) {
      router.dismiss()
      return
    }
    if (router.canGoBack()) {
      router.back()
      return
    }
  }
  const onPress = useThrottledCallback(goBack, 350, { leading: true })
  return (
    <Modal transparent visible>
      <View
        style={{
          flex: 1,
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: palette.blackWithOpacity.twenty
        }}
      >
        <View
          style={{
            backgroundColor: palette.cream,
            borderRadius: 12,
            marginHorizontal: 24,
            maxWidth: 600,
            justifyContent: 'center',
            alignSelf: 'center'
          }}
        >
          <View style={styles.modalContainer}>
            <DS.Frame style={[styles.container, { alignItems: 'center', gap: DS.spacing[8] }]}>
              <View style={{ marginBottom: 8 }}>
                <DS.Icon name="Minus--enclosed" width={40} height={40} />
              </View>
              <DS.Text variant="Heading 3/Medium">{translate('gameScreen.joinGameUnableTitle')}</DS.Text>
              <DS.Text variant="Body Small/Regular">{translate('gameScreen.joinGameUnableMessage')}</DS.Text>
              <DS.Frame style={{ height: 8, width: '100%', marginVertical: DS.spacing[8] }} />
              <DS.Button variant="Large/Primary" type="On Light" onPress={onPress}>
                Close
              </DS.Button>
            </DS.Frame>
          </View>
        </View>
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: DS.palette['Brand/Cream'],
    alignItems: 'center',
    paddingHorizontal: 16,
    borderRadius: 20
  },
  container: {
    width: '100%',
    paddingVertical: 24,
    gap: 20
  }
})
